import { withFilters } from '@sbv-clients/domain-ui-shared';

import {
  FacilityStatusContext,
  useFacilityStatusContext,
} from './page-context';

const Context = withFilters(
  useFacilityStatusContext,
  FacilityStatusContext,
  'MasterSchedulePlanner'
);

export const Page = Context.Page;
export const useContextFn = Context.useContextFn;
